import { AxiosResponse } from 'axios';

import {
  CombineCarbonFootprintI,
  EquivalentI,
  HotelCarbonFootprintI,
  TransportCarbonFootprintI,
} from '../../declarations/interfaces/calculator';
import { post } from '../api';
import {
  GetCarbonFootprintCalculationDTO,
  GetHotelCarbonFootprintCalculationDTO,
  GetTransportCarbonFootprintCalculationDTO,
} from './calculator.d';

export const getHotelCarbonFootprint = async (
  data: GetHotelCarbonFootprintCalculationDTO
): Promise<AxiosResponse<HotelCarbonFootprintI>> => await post('/cfc/calculate/hotel', data);

export const getTransportCarbonFootprint = async (
  data: GetTransportCarbonFootprintCalculationDTO
): Promise<AxiosResponse<TransportCarbonFootprintI>> =>
  await post('/cfc/calculate/transport', data);

export const getCarbonFootprint = async (
  data: GetCarbonFootprintCalculationDTO
): Promise<AxiosResponse<CombineCarbonFootprintI>> => await post('/cfc/calculate', data);

export const getEquivalents = async (
  totalToOffsetInTonnes: number
): Promise<AxiosResponse<EquivalentI[]>> =>
  await post('/cfc/contextualization/equivalents/localization', { mass: totalToOffsetInTonnes });
